import {
  ENV_ACCOUNT_ID,
  ENV_CREDENTIAL_SCOPE,
  ENV_EXPIRATION,
  ENV_KEY,
  ENV_SECRET,
  ENV_SESSION,
  fromEnv
} from "./chunk-2MDTVCRU.js";
import "./chunk-C3MO6XIN.js";
import "./chunk-Q3SYTXLO.js";
import "./chunk-7CQDH4SB.js";
export {
  ENV_ACCOUNT_ID,
  ENV_CREDENTIAL_SCOPE,
  ENV_EXPIRATION,
  ENV_KEY,
  ENV_SECRET,
  ENV_SESSION,
  fromEnv
};
//# sourceMappingURL=dist-es-J5YS6SQF.js.map